import { Button, Dialog, DialogTrigger, Popover, Tooltip, TooltipTrigger } from "react-aria-components";

/** One canonical string, available to hover, keyboard and touch. */
export function MerryQuoteDisclosure({ text, className }: { text: string; className?: string }) {
  return <DialogTrigger><TooltipTrigger delay={300}>
    <Button aria-label={`查看完整引用：${text}`} className={className}>{text}</Button>
    <Tooltip className="merry-quote-disclosure">{text}</Tooltip>
  </TooltipTrigger><Popover placement="top" className="merry-quote-disclosure">
    <Dialog aria-label="完整引用">{text}</Dialog>
  </Popover></DialogTrigger>;
}
